import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { T_R } from '../constants';

export const isTableRow = isElementType(T_R);
